<template>
  <div>
    <p
      class="font-weight-bold mt-6 px-8"
      :class="yellow_vest_comment && 'mb-0'"
    >
      Gulvästar
    </p>
    <p class="px-8 text-body-2 text--secondary">
      {{ yellow_vest_comment }}
    </p>
    <TrafficMessageRow :items="list" />
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import TrafficMessageRow from './TrafficMessageRow'
import diffFactory from '@/helpers/diffFactory'

export default {
  name: 'TrafficMessageYellowVestText',

  components: {
    TrafficMessageRow
  },

  computed: {
    yellow_vest_comment: get('trafficMessage/model@yellow_vest_comment'),
    yellowVests: get('yellowVest/data'),
    model: get('trafficMessage/model'),
    stops: get('event/stops'),

    list() {
      const findLocationName = signature => {
        const location = this.stops.find(
          x => x.short_name === signature.toUpperCase()
        )
        return location ? location.stop_name : signature.toUpperCase()
      }

      return diffFactory(
        this.model.yellow_vests,
        x =>
          `${findLocationName(x.location)}, Behov: ${x.demand}, Tillsatta: ${
            x.assigned
          }`,
        this.yellowVests
      )
    }
  }
}
</script>
